import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';

import messages from '../../messages';
import style from '../edit-amount-summary-modal.module.less';

const shipmentColumnId = 'edit-shipment-column';

const Shipment = ({ value: index }) => (
  <div className={style['shipment-cell']}>
    {index === 0 ? (
      <FormattedMessage {...messages.order} />
    ) : (
      <FormattedMessage {...messages.shipmentLabel} values={{ index: <FormattedNumber value={index} /> }} />
    )}
  </div>
);

Shipment.propTypes = {
  value: PropTypes.number.isRequired,
};

const shipmentColumnDefinition = createColumnDefinitionBuilder({
  header: undefined,
  accessor: shipmentColumnId,
  cell: Shipment,
  width: 1.5,
});

export { shipmentColumnId, shipmentColumnDefinition };
